import { MDSTheme, MDSTypography } from '@marqvision/mds/core';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../apis/auth';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  link: {
    textDecoration: 'none',
  },
  white: {
    color: MDSTheme.palette.white,
    transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      color: MDSTheme.palette.bluegray[800],
    },
  },
  bluegray: {
    color: MDSTheme.palette.bluegray[800],
    transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      color: MDSTheme.palette.bluegray[700],
    },
  },
}));

const HeaderLink = ({
  to,
  children,
  color,
  login,
  onClick,
}: React.PropsWithChildren<{
  to: string;
  color: 'white' | 'bluegray';
  login?: (fn: () => void) => void;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}>): React.ReactNode => {
  const classes = useStyles();

  const { data: authData } = useAuth();
  const navigate = useNavigate();

  const text = (
    <MDSTypography variant="T16" weight="medium" className={classes[color]}>
      {children}
    </MDSTypography>
  );

  if (!!login && !authData?.accessToken) {
    return (
      <div
        style={{ cursor: 'pointer' }}
        onClick={(e) => {
          onClick && onClick(e);
          login(() => navigate(to));
        }}
      >
        {text}
      </div>
    );
  }

  return (
    <Link
      to={to}
      className={classes.link}
      onClick={(e) => onClick?.(e as unknown as React.MouseEvent<HTMLDivElement, MouseEvent>)}
    >
      {text}
    </Link>
  );
};

export default HeaderLink;
